import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { ParameterModel, parameter } from '../interfaces/parameter.model';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class ParametersService {
  private baseUrl = `${environment.apiEndpoint}/Parameter`;
  //se estaba usando demaciado el getter de todos los params asi que lo guardo para evitar calls.
  private saved_params: ParameterModel = null;

  constructor(private http: HttpClient, private auth: AuthService) { }


  getAllParameters(): Promise<ParameterModel> {
    if (this.saved_params) {
      return Promise.resolve(this.saved_params);
    }

    return new Promise((resolve, reject) => {
      this.http.get(this.baseUrl).subscribe(
        (res: any[]) => {
          let parametros: any = {};

          res.forEach((param: any) => {
            parametros[param.name] = param;
          });

          this.saved_params = parametros;
          resolve(parametros);
        },
        (error) => {
          Swal.fire(
            'Ups!',
            'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.',
            'error'
          );
          reject(error);
        }
      );
    });
  }

  getParameterById(id: number): Promise<parameter> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().append('id', String(id));
      this.http.get<parameter>(`${this.baseUrl}/GetById`, { params }).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getAllSubPrices(): Promise<parameter[]> {
    return new Promise((resolve, reject) => {
      this.http.get<parameter[]>(`${this.baseUrl}/GetAllSubPrices`).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getFOBannerBoolean(): Promise<parameter> {
    return new Promise((resolve, reject) => {
      this.http.get<parameter[]>(`${this.baseUrl}/GetFOBannerBoolean`).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }
}
